import axios from 'axios';

// Configuración de la URL de la API
const getApiBase = () => {
  // En desarrollo local
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001/api';
  }
  
  // En producción (Vercel), usar la misma URL que el frontend
  return '/api';
};

const API_BASE = getApiBase();

export const generatePlaylist = ({ country }) => {
  return axios.post(`${API_BASE}/generate-playlist`, {
    country
  }).then(res => res.data);
};